import { Pencil, Trash2, KeyRound, ShieldCheck } from "lucide-react";
import { ROLE_LABEL } from "./roleLabels";

export const EmployeeCard = ({ employee: e, canWrite, canDelete, isAdmin, openEdit, onDelete, onClearPin }) => (
  <div
    data-testid={`employee-card-${e.id}`}
    onClick={() => canWrite && openEdit(e)}
    role={canWrite ? "button" : undefined}
    tabIndex={canWrite ? 0 : undefined}
    className={`p-4 active:bg-[#f5f1ec] select-none ${canWrite ? "cursor-pointer" : ""}`}
  >
    <div className="flex items-start justify-between gap-3 mb-3">
      <div className="min-w-0 flex-1">
        <div className="font-semibold text-[#33424f] truncate">{e.name}</div>
        <div className="text-xs text-[#50493b] mt-0.5">{ROLE_LABEL[e.role] || e.role}</div>
      </div>
      <span
        className={`text-[10px] font-semibold uppercase tracking-wider px-2 py-1 border shrink-0 ${
          e.active ? "text-[#2d5e1f] border-[#2d5e1f]/30 bg-[#e8f6e2]" : "text-[#50493b] border-[#50493b]/30 bg-[#f5f1ec]"
        }`}
      >
        {e.active ? "Active" : "Archived"}
      </span>
    </div>
    <div data-testid={`employee-card-login-${e.id}`}>
      {e.login_enabled ? (
        <span className="inline-flex items-center gap-1 text-[10px] subtitle uppercase tracking-[0.2em] text-[#1f4715] bg-[#e6f1df] border border-[#2d5e1f]/30 px-2 py-0.5">
          <ShieldCheck className="w-3 h-3" /> {e.username}
        </span>
      ) : (
        <span className="text-[10px] subtitle uppercase tracking-[0.2em] text-[#50493b]/60">No login</span>
      )}
    </div>
    {(isAdmin || canWrite || canDelete) && (
      <div className="flex items-center justify-end gap-2 mt-4 pt-3 border-t border-[#33424f]/10" onClick={(ev) => ev.stopPropagation()}>
        {isAdmin && e.login_enabled && (
          <button
            data-testid={`revoke-login-card-${e.id}`}
            onClick={() => onClearPin(e)}
            className="px-3 py-2 hover:bg-[#fbf1dc] text-[#b9832a] inline-flex items-center gap-1.5 text-xs subtitle uppercase tracking-[0.15em] border border-[#b9832a]/30"
            title="Revoke login (clear PIN)"
          >
            <KeyRound className="w-3.5 h-3.5" />
          </button>
        )}
        {canWrite && (
          <button
            data-testid={`edit-employee-card-${e.id}`}
            onClick={() => openEdit(e)}
            className="px-3 py-2 hover:bg-[#e6e0db] text-[#33424f] inline-flex items-center gap-1.5 text-xs subtitle uppercase tracking-[0.15em] border border-[#33424f]/20"
          >
            <Pencil className="w-3.5 h-3.5" /> Edit
          </button>
        )}
        {canDelete && (
          <button
            data-testid={`delete-employee-card-${e.id}`}
            onClick={() => onDelete(e)}
            className="px-3 py-2 hover:bg-[#fbe4ea] text-[#b30035] inline-flex items-center gap-1.5 text-xs subtitle uppercase tracking-[0.15em] border border-[#b30035]/30"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    )}
  </div>
);
